import {
  useListActiveMealsForCongressIdQuery,
  useListMealsForCongressIdQuery,
} from "../store/activity/activity";
import { Activity } from "../types/activity.types";

interface UseMealsQueryResult {
  mealList: Activity[];
  areMealsLoading: boolean;
}

export const useMealsQuery = (
  congressId: number,
  isEditMode: boolean
): UseMealsQueryResult => {
  const mealsPublicQuery = useListActiveMealsForCongressIdQuery(congressId, {
    skip: isEditMode,
  });
  const mealsHiddenQuery = useListMealsForCongressIdQuery(congressId, {
    skip: !isEditMode,
  });

  const mealList = isEditMode
    ? mealsHiddenQuery.data ?? []
    : mealsPublicQuery.data ?? [];
  const areMealsLoading = isEditMode
    ? mealsHiddenQuery.isLoading
    : mealsPublicQuery.isLoading;

  return {
    mealList,
    areMealsLoading,
  };
};
